import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-charcoal-800 text-cream-100 pt-16 pb-6">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-charcoal-700">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <img
              src="https://static.readdy.ai/image/b56ddf5676badcd01c30e06215815ec0/bb1c6698515d81ebf3fbedc388c9a65a.png"
              alt="Sweet Celebrations"
              className="h-16 w-auto object-contain"
            />
            <p className="text-warm-gray text-sm leading-relaxed">
              Handcrafted with love and creativity in Lubbock, Texas since 2007.
            </p>
            <div className="flex gap-3 mt-2">
              <a
                href="https://www.facebook.com/scbakeacake"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-blush-400 text-blush-400 hover:bg-blush-500 hover:text-white hover:border-blush-500 transition-all duration-200 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg" />
              </a>
              <a
                href="https://www.instagram.com/sherry_sweet_celebrations/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-blush-400 text-blush-400 hover:bg-blush-500 hover:text-white hover:border-blush-500 transition-all duration-200 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg" />
              </a>
            </div>
          </div>

          {/* Explore */}
          <div className="flex flex-col gap-4">
            <h4 className="text-cream-100 font-sans font-bold text-base uppercase tracking-widest">
              <a href="#explore">Explore</a>
            </h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-warm-gray hover:text-blush-400 text-sm transition-colors duration-200 cursor-pointer">Home</Link>
              <Link to="/about" className="text-warm-gray hover:text-blush-400 text-sm transition-colors duration-200 cursor-pointer">About</Link>
              <Link to="/custom-orders" className="text-warm-gray hover:text-blush-400 text-sm transition-colors duration-200 cursor-pointer">Custom Orders</Link>
              <a href="/#gallery" className="text-warm-gray hover:text-blush-400 text-sm transition-colors duration-200 cursor-pointer">Gallery</a>
            </div>
          </div>

          {/* Services */}
          <div className="flex flex-col gap-4">
            <h4 className="text-cream-100 font-sans font-bold text-base uppercase tracking-widest">
              <a href="#services">Services</a>
            </h4>
            <div className="flex flex-col gap-3">
              <a href="/#classes" className="text-warm-gray hover:text-blush-400 text-sm transition-colors duration-200 cursor-pointer">Classes &amp; Supplies</a>
              <a href="/#contact" className="text-warm-gray hover:text-blush-400 text-sm transition-colors duration-200 cursor-pointer">Contact</a>
              <Link to="/custom-orders" className="text-warm-gray hover:text-blush-400 text-sm transition-colors duration-200 cursor-pointer">Custom Cakes</Link>
              <Link to="/custom-orders" className="text-warm-gray hover:text-blush-400 text-sm transition-colors duration-200 cursor-pointer">Cookies &amp; Pastries</Link>
            </div>
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-4">
            <h4 className="text-cream-100 font-sans font-bold text-base uppercase tracking-widest">
              <a href="#contact">Connect</a>
            </h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 text-warm-gray text-sm">
                <i className="ri-map-pin-line text-blush-400" />
                <span>Lubbock, Texas</span>
              </div>
              <a
                href="https://www.facebook.com/scbakeacake"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center gap-2 text-warm-gray hover:text-blush-400 text-sm transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-facebook-fill text-blush-400" />
                <span>@scbakeacake</span>
              </a>
              <a
                href="https://www.instagram.com/sherry_sweet_celebrations/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="flex items-center gap-2 text-warm-gray hover:text-blush-400 text-sm transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-instagram-line text-blush-400" />
                <span>@sherry_sweet_celebrations</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-warm-gray text-xs">&copy; {currentYear} Sweet Celebrations. All rights reserved.</p>
          <p className="text-warm-gray text-xs">
            Website by{' '}
            <strong className="text-blush-400">Caprock Web Co.</strong>
          </p>
          <a href="#privacy" className="text-warm-gray hover:text-blush-400 text-xs transition-colors duration-200 cursor-pointer">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
}
